<script setup lang="ts">
import { computed } from 'vue';
import { useUi } from '@/stores/ui';
import UiButton from './UiButton.vue';
import UiModal from './UiModal.vue';

const ui = useUi();
const open = computed({
  get: () => !!ui.confirmState,
  set: (v) => {
    if (!v) ui.answer(false);
  },
});
</script>

<template>
  <UiModal v-model="open" :title="ui.confirmState?.title" :width="420">
    <p v-if="ui.confirmState?.text" class="muted">{{ ui.confirmState.text }}</p>
    <template #footer>
      <UiButton variant="ghost" @click="ui.answer(false)">Отмена</UiButton>
      <UiButton :variant="ui.confirmState?.danger ? 'danger' : 'primary'" @click="ui.answer(true)">
        {{ ui.confirmState?.confirmLabel ?? 'Подтвердить' }}
      </UiButton>
    </template>
  </UiModal>
</template>
